import { render, staticRenderFns } from "./VirtualColleagueNavigation.vue?vue&type=template&id=843d4bc4&scoped=true&"
import script from "./VirtualColleagueNavigation.vue?vue&type=script&lang=ts&"
export * from "./VirtualColleagueNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./VirtualColleagueNavigation.vue?vue&type=style&index=0&id=843d4bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843d4bc4",
  null
  
)

export default component.exports